# Спецификация https://gitlab.whymy.ru/snippets/27

# todo i18n
# весь файл надо анализировать
# todo i18n

module.exports = App.ReportSchema = DS.Model.extend
  name: DS.attr 'string'
  description: DS.attr 'string'
  filters: DS.attr 'mixed'
  group_by_array: DS.attr 'boolean'
  group_by: DS.attr 'mixed'

App.ReportSchemaAdapter = DS.FixtureAdapter

# todo i18n
window.REPORT_SOURCE_SELECT = [
  { "name": "Board",                                 "id": "board" },
  { "name": "Витрина Смартомато",                    "id": "marketplace" },
  { "name": "Витрина Смартомато (мобильная версия)", "id": "marketplace_mobile" },
  { "name": "Внешний сайт",                          "id": "external_site" },
  { "name": "Внешний сайт (мобильная версия)",       "id": "external_site_mobile" },
  { "name": "Мобильное приложение (iOS)",            "id": "mobile_application_ios" },
  { "name": "Мобильное приложение (Android)",        "id": "mobile_application_android" },
  { "name": "Яндекс.Еда",                            "id": "foodfox" },
  { "name": "Яндекс.Лавка",                          "id": "yandex_lavka" },
  { "name": "Delivery Club",                         "id": "delivery_club" },
  { "name": "Obed.ru",                               "id": "obed_ru" },
  { "name": "Broniboy",                              "id": "broniboy" },
  { "name": "Chibbis",                               "id": "chibbis" },
  { "name": "Glovo",                                 "id": "glovo" },
  { "name": "Sbermarket",                            "id": "sbermarket" },
  { "name": "Vk",                                    "id": "vk" },
]

App.ReportSchema.reopenClass
  FIXTURES: [
    {
      id: 'availability'
      # todo i18n
      name: 'Доступность блюд и заведений'
      description: "Отчет позволяет получить информацию об истории нахождения блюд в стоп-листах и доступности ресторанов для приема заказов"
      filters: [
        "name":           "Период отчета",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "created_at",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ,
        "name": "Категории блюд"
        "control_type": "select"
        "control_options":
          "select_assosiation": "categories"
        "allow_multiple":  true
        "field": "category_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ]
      group_by: [
        # todo i18n
        { "group_value": "restaurants", "group_name": "Работа заведений (детали)" },
        { "group_value": "restaurants_summary", "group_name": "Работа заведений (суммарно)" },
        { "group_value": "dishes", "group_name": "Блюда в ресторанах (от блюд)" },
        { "group_value": "restaurant_dishes", "group_name": "Блюда в ресторанах (от ресторана)" },
      ]

    },
    {
      id: 'cohort_analysis'
      # todo i18n
      name: 'Когортный анализ'
      description: "Информация о том, как заказывали разные группы клиентов"
      # todo i18n
      filters: [
        "name":           "Период заказов",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "orders.created_at",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ,
        "name":           "Период появления клиента",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "clients.created_at",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ,
        "name": "Курьер"
        "control_type": "select"
        "control_options":
          "select_assosiation": "couriers"
        "allow_multiple":  true
        "field": "courier_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Способ оплаты"
        "control_type": "select"
        "field": "payment_source"
        "allow_multiple":  true
        "control_options":
          "select_options": [
            { "name": "Наличные",       "id": "cash" },
            { "name": "Карта", "id": "card" },
            { "name": "Картой курьеру",   "id": "courier_card" },
            { "name": "Картой на внешнем сервисе", "id": "external_service_card_online" },
          ]
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Зона доставки"
        "control_type": "select"
        "control_options":
          "select_assosiation": "delivery_zones"
        "allow_multiple":  true
        "field": "delivery_zone_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Ресторан"
        "control_type": "select"
        "control_options":
          "select_assosiation": "restaurants"
        "allow_multiple":  true
        "field": "restaurant_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Организация"
        "control_type": "select"
        "control_options":
          "select_assosiation": "organizations"
        "allow_multiple":  true
        "field": "organization_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Статус заказа"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Новый",       "id": "pending" },
            { "name": "Подтвержден", "id": "confirm" },
            { "name": "Готовится",   "id": "preparing" },
            { "name": "Приготовлен", "id": "prepared" },
            { "name": "У курьера",   "id": "delivery" },
            { "name": "Доставлен",   "id": "complete" },
            { "name": "Отменен",     "id": "undo" },
          ]
        "allow_multiple": true
        "field": "status"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,
        "name": "Источник"
        "control_type": "select"
        "control_options":
          "select_options": window.REPORT_SOURCE_SELECT
        "allow_multiple": true
        "field": "source"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,
        "name": "Аутсорс доставки"
        "control_type": "select"
        "field": "external_delivery_provider"
        "control_options":
          "select_options": [
            { "name": "Своя",         "id": null },
            { "name": "YandexGo",     "id": "yandex_go" },
            { "name": "Broniboy",     "id": "broniboy" },
            { "name": "Dostavista",   "id": "dostavista" },
            { "name": "DeliveryClub", "id": "dc_last_mile" },
          ]
        "allow_multiple":  true
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ]
      group_by: [
        { "group_value": "month", "group_name": "Помесячно" },
        { "group_value": "week", "group_name": "Понедельно" },
      ]

    },
    # todo i18n
    {
      id: 'sales'
      name: 'Выгрузка проданных блюд'
      description: "Отчет позволяет получить данные о продажах блюд"

      filters: [
        "name":           "Дата доставки",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "delivery_at",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ,
        "name": "Имя клиента"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "contact_name"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "Номер телефона клиента"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "contact_phone"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "Курьер"
        "control_type": "select"
        "control_options":
          "select_assosiation": "couriers"
        "allow_multiple":  true
        "field": "courier_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Способ получения"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Доставка",       "id": "delivery" },
            { "name": "Самовывоз",        "id": "takeaway" },
            { "name": "К столу",        "id": "dine_in" },
          ]
        "allow_multiple": false
        "field": "delivery_type",
        "field_type": "string"
        "allowed_operators": [ '$eq' ]
      ,
        "name": "Зона доставки"
        "control_type": "select"
        "control_options":
          "select_assosiation": "delivery_zones"
        "allow_multiple":  true
        "field": "delivery_zone_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Ресторан"
        "control_type": "select"
        "control_options":
          "select_assosiation": "restaurants"
        "allow_multiple":  true
        "field": "restaurant_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Организация"
        "control_type": "select"
        "control_options":
          "select_assosiation": "organizations"
        "allow_multiple":  true
        "field": "organization_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Статус заказа"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Новый",       "id": "pending" },
            { "name": "Подтвержден", "id": "confirm" },
            { "name": "Готовится",   "id": "preparing" },
            { "name": "Приготовлен", "id": "prepared" },
            { "name": "У курьера",   "id": "delivery" },
            { "name": "Доставлен",   "id": "complete" },
            { "name": "Отменен",     "id": "undo" },
          ]
        "allow_multiple": true
        "field": "status"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,
        "name": "Источник"
        "control_type": "select"
        "control_options":
          "select_options": window.REPORT_SOURCE_SELECT
        "allow_multiple": true
        "field": "source"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,
        "name": "Аутсорс доставки"
        "control_type": "select"
        "field": "external_delivery_provider"
        "control_options":
          "select_options": [
            { "name": "Своя",         "id": null },
            { "name": "YandexGo",     "id": "yandex_go" },
            { "name": "Broniboy",     "id": "broniboy" },
            { "name": "Dostavista",   "id": "dostavista" },
            { "name": "DeliveryClub", "id": "dc_last_mile" },
          ]
        "allow_multiple":  true
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
        ,
          "name": "Категория блюд"
          "control_type": "select"
          "control_options":
            "select_assosiation": "categories"
          "allow_multiple":  true
          "field": "item_category_id"
          "field_type": "integer"
          "allowed_operators": [ '$eq', '$not_eq', '$in' ]
        ,
          "name": "Блюда"
          "control_type": "select"
          "control_options":
            "select_assosiation": "dishes"
          "allow_multiple":  true
          "field": "item_dish_id"
          "field_type": "integer"
          "allowed_operators": [ '$eq', '$not_eq', '$in' ]
        ,
          "name": "Оператор"
          "control_type": "select"
          "control_options":
            "select_assosiation": "staff_member"
          "allow_multiple":  true
          "field": "confirmed_by"
          "field_type": "integer"
          "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ]

      group_by: [
      ]
    },
    {
      # todo i18n
      id: 'sales_report'
      name: 'Аналитика продаж'
      description: "Отчет позволяет проанализировать покупку блюд"

      filters: [

        "name": "Количество продаж",
        "control_type":   "textfield",
        "control_options": {}
        "allow_multiple": true
        "field":          "sales_count",
        "field_type":     "number"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
      ,
        "name":           "Дата доставки",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "delivery_at",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ,
        "name": "Имя клиента"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "contact_name"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "Курьер"
        "control_type": "select"
        "control_options":
          "select_assosiation": "couriers"
        "allow_multiple":  true
        "field": "courier_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Оператор"
        "control_type": "select"
        "control_options":
          "select_assosiation": "staff_members"
        "allow_multiple":  true
        "field": "confirmed_by"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Категория блюд"
        "control_type": "select"
        "control_options":
          "select_assosiation": "organization.categories_tree_view",
          "labelKey": "name_for_tree",
        "allow_multiple":  true
        "field": "category_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Способ получения"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Доставка",       "id": "delivery" },
            { "name": "Самовывоз",        "id": "takeaway" },
            { "name": "К столу",        "id": "dine_in" },
          ]
        "allow_multiple": false
        "field": "delivery_type",
        "field_type": "string"
        "allowed_operators": [ '$eq' ]
      ,
        "name": "Зона доставки"
        "control_type": "select"
        "control_options":
          "select_assosiation": "delivery_zones"
        "allow_multiple":  true
        "field": "delivery_zone_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Ресторан"
        "control_type": "select"
        "control_options":
          "select_assosiation": "restaurants"
        "allow_multiple":  true
        "field": "restaurant_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Способ оплаты"
        "control_type": "select"
        "field": "payment_source"
        "allow_multiple":  true
        "control_options":
          "select_options": [
            { "name": "Наличные",       "id": "cash" },
            { "name": "Карта", "id": "card" },
            { "name": "Картой курьеру",   "id": "courier_card" },
            { "name": "Картой на внешнем сервисе", "id": "external_service_card_online" },
          ]
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Организация"
        "control_type": "select"
        "control_options":
          "select_assosiation": "organizations"
        "allow_multiple":  true
        "field": "organization_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Статус заказа"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Новый",       "id": "pending" },
            { "name": "Подтвержден", "id": "confirm" },
            { "name": "Готовится",   "id": "preparing" },
            { "name": "Приготовлен", "id": "prepared" },
            { "name": "У курьера",   "id": "delivery" },
            { "name": "Доставлен",   "id": "complete" },
            { "name": "Отменен",     "id": "undo" },
          ]
        "allow_multiple": true
        "field": "status"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,
        "name": "Источник"
        "control_type": "select"
        "control_options":
          "select_options": window.REPORT_SOURCE_SELECT
        "allow_multiple": true
        "field": "source"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,
        "name": "Аутсорс доставки"
        "control_type": "select"
        "field": "external_delivery_provider"
        "control_options":
          "select_options": [
            { "name": "Своя",         "id": null },
            { "name": "YandexGo",     "id": "yandex_go" },
            { "name": "Broniboy",     "id": "broniboy" },
            { "name": "Dostavista",   "id": "dostavista" },
            { "name": "DeliveryClub", "id": "dc_last_mile" },
          ]
        "allow_multiple":  true
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ]

      group_by: [
        { "group_value": "", "group_name": "Без группировки" },
        { "group_value": "day", "group_name": "День" },
        { "group_value": "weekday", "group_name": "День недели" },
        { "group_value": "week", "group_name": "Неделя" }
        { "group_value": "month", "group_name": "Месяц" }
      ]
    },
    {
      id: 'orders'
      name: 'Отчет по заказам'
      description: "Отчет позволяет получить данные о заказах с группировкой по дате, курьеру или зоне доставки"

      filters: [
        "name":           "Дата доставки",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "delivery_at",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ,
        "name":           "Дата поступления",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "created_at",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ,
        "name": "Имя клиента"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "contact_name"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "Курьер"
        "control_type": "select"
        "control_options":
          "select_assosiation": "couriers"
        "allow_multiple":  true
        "field": "courier_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Способ получения"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Доставка",       "id": "delivery" },
            { "name": "Самовывоз",        "id": "takeaway" },
            { "name": "К столу",        "id": "dine_in" },
          ]
        "allow_multiple": false
        "field": "delivery_type",
        "field_type": "string"
        "allowed_operators": [ '$eq' ]
      ,

        "name": "Когда доставить"

        "control_type": "select"
        "field": "delivery_asap"
        "allow_multiple":  false
        "control_options":
          "select_options": [
            { "name": "Как можно скорее", "id": "1" },
            { "name": "К определенному времени",   "id": "0" },
          ]

        "field_type": "boolean"
        "allowed_operators": [ '$eq' ]
      ,
        "name": "Способ оплаты"
        "control_type": "select"
        "field": "payment_source"
        "allow_multiple":  true
        "control_options":
          "select_options": [
            { "name": "Наличные",       "id": "cash" },
            { "name": "Карта", "id": "card" },
            { "name": "Картой курьеру",   "id": "courier_card" },
            { "name": "Картой на внешнем сервисе", "id": "external_service_card_online" },
          ]
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Оплачен (для карты)"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Нет",       "id": false },
            { "name": "Да",        "id": true },
          ]
        "allow_multiple": false
        "field": "payment_success"
        "field_type": "boolean"
        "allowed_operators": [ '$eq' ]
      ,
        "name": "Зона доставки"
        "control_type": "select"
        "control_options":
          "select_assosiation": "delivery_zones"
        "allow_multiple":  true
        "field": "delivery_zone_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Ресторан"
        "control_type": "select"
        "control_options":
          "select_assosiation": "restaurants"
        "allow_multiple":  true
        "field": "restaurant_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Организация"
        "control_type": "select"
        "control_options":
          "select_assosiation": "organizations"
        "allow_multiple":  true
        "field": "organization_id"
        "field_type": "integer"
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ,
        "name": "Статус заказа"
        "control_type": "select"
        "control_options":
          "select_options": [
            { "name": "Новый",       "id": "pending" },
            { "name": "Подтвержден", "id": "confirm" },
            { "name": "Готовится",   "id": "preparing" },
            { "name": "Приготовлен", "id": "prepared" },
            { "name": "У курьера",   "id": "delivery" },
            { "name": "Доставлен",   "id": "complete" },
            { "name": "Отменен",     "id": "undo" },
          ]
        "allow_multiple": true
        "field": "status"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,

        "name": "UTM Source"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "utm_source"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "UTM Medium"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "utm_medium"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "UTM Campaign"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "utm_campaign"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "UTM Term"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "utm_term"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,
        "name": "UTM Content"
        "control_type": "textfield"
        "control_options": {}
        "allow_multiple": true
        "field": "utm_content"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq', '$contains' ]
      ,


        "name": "Источник"
        "control_type": "select"
        "control_options":
          "select_options": window.REPORT_SOURCE_SELECT
        "allow_multiple": true
        "field": "source"
        "field_type": "string"
        "allowed_operators": [ '$eq', '$not_eq' ]
      ,
        "name": "Аутсорс доставки"
        "control_type": "select"
        "field": "external_delivery_provider"
        "control_options":
          "select_options": [
            { "name": "Своя",         "id": null },
            { "name": "YandexGo",     "id": "yandex_go" },
            { "name": "Broniboy",     "id": "broniboy" },
            { "name": "Dostavista",   "id": "dostavista" },
            { "name": "DeliveryClub", "id": "dc_last_mile" },
          ]
        "allow_multiple":  true
        "allowed_operators": [ '$eq', '$not_eq', '$in' ]
      ]

      group_by_array: true,
      group_by: [
        { "group_value": "hour", "group_name": "Час" },
        { "group_value": "day", "group_name": "День" },
        { "group_value": "weekday", "group_name": "День недели" }
        { "group_value": "week", "group_name": "Неделя" },
        { "group_value": "month", "group_name": "Месяц" },
        { "group_value": "recurrence", "group_name": "Возвращаемость" },
        { "group_value": "delivery_zone_id", "group_name": "Зона" },
        { "group_value": "promo_code_text", "group_name": "Использованный промокод" },
        { "group_value": "source", "group_name": "Источник заказа" },
        { "group_value": "tag", "group_name": "Категория" }
        { "group_value": "courier_id", "group_name": "Курьер" },

        { "group_value": "confirmed_by", "group_name": "Оператор" },
        { "group_value": "organization_id", "group_name": "Организация"},
        { "group_value": "delivery_asap", "group_name": "Отложенный или ASAP" },
        { "group_value": "client_rate", "group_name": "Оценка" },
        { "group_value": "promo", "group_name": "Примененная акция" },
        { "group_value": "cancel_reason", "group_name": "Причина отмены заказа" },
        { "group_value": "distance", "group_name": "Расстояние" },
        { "group_value": "restaurant_id", "group_name": "Ресторан" },
        { "group_value": "payment_source", "group_name": "Способ оплаты" },
        { "group_value": "status", "group_name": "Статус" },

        { "group_value": "utm_source", "group_name": "UTM Source" },
        { "group_value": "utm_medium", "group_name": "UTM Medium" },
        { "group_value": "utm_campaign", "group_name": "UTM Campaign" },
        { "group_value": "utm_term", "group_name": "UTM Term" },
        { "group_value": "utm_content", "group_name": "UTM Content" },

      ]
    },
    {
      id: 'couriers'
      name: 'Отчет по курьерам'
      description: "Отчет позволяет получить о курьерах, количестве отработанных часов и гонорарах"
      filters: [
        "name":           "Период",
        "control_type":   "datetime_range",
        "control_options": {}
        "allow_multiple": true
        "field":          "work_period",
        "field_type":     "date"
        "allowed_operators": [ '$lte', '$gte', '$eq', '$not_eq' ]
        "is_range": true
      ]
      group_by: [
      ]
    },
  ]
